// A small curated set of major world airports with coordinates, used by the
// "I'm feeling lucky" future-flight picker. Not exhaustive — just enough spread
// to find a plausible departure airport inside the current map view and a fun
// destination anywhere in the world. Shape matches what Preview3D expects:
// { icao, iata, name, latitude, longitude }.
export const SAMPLE_AIRPORTS = [
  { icao: "EGLL", iata: "LHR", name: "London Heathrow", latitude: 51.4706, longitude: -0.4619 },
  { icao: "EGKK", iata: "LGW", name: "London Gatwick", latitude: 51.1481, longitude: -0.1903 },
  { icao: "EHAM", iata: "AMS", name: "Amsterdam Schiphol", latitude: 52.3086, longitude: 4.7639 },
  { icao: "LFPG", iata: "CDG", name: "Paris Charles de Gaulle", latitude: 49.0097, longitude: 2.5479 },
  { icao: "EDDF", iata: "FRA", name: "Frankfurt", latitude: 50.0333, longitude: 8.5706 },
  { icao: "LEMD", iata: "MAD", name: "Madrid Barajas", latitude: 40.4936, longitude: -3.5668 },
  { icao: "LEBL", iata: "BCN", name: "Barcelona El Prat", latitude: 41.2971, longitude: 2.0785 },
  { icao: "LIRF", iata: "FCO", name: "Rome Fiumicino", latitude: 41.8003, longitude: 12.2389 },
  { icao: "LSZH", iata: "ZRH", name: "Zurich", latitude: 47.4647, longitude: 8.5492 },
  { icao: "EIDW", iata: "DUB", name: "Dublin", latitude: 53.4213, longitude: -6.2701 },
  { icao: "EKCH", iata: "CPH", name: "Copenhagen", latitude: 55.6181, longitude: 12.6561 },
  { icao: "ENGM", iata: "OSL", name: "Oslo Gardermoen", latitude: 60.1939, longitude: 11.1004 },
  { icao: "LTFM", iata: "IST", name: "Istanbul", latitude: 41.2753, longitude: 28.7519 },
  { icao: "UUEE", iata: "SVO", name: "Moscow Sheremetyevo", latitude: 55.9726, longitude: 37.4146 },
  { icao: "OMDB", iata: "DXB", name: "Dubai", latitude: 25.2532, longitude: 55.3657 },
  { icao: "OTHH", iata: "DOH", name: "Doha Hamad", latitude: 25.2731, longitude: 51.6081 },
  { icao: "VIDP", iata: "DEL", name: "Delhi Indira Gandhi", latitude: 28.5562, longitude: 77.1 },
  { icao: "VABB", iata: "BOM", name: "Mumbai", latitude: 19.0887, longitude: 72.8679 },
  { icao: "VHHH", iata: "HKG", name: "Hong Kong", latitude: 22.308, longitude: 113.9185 },
  { icao: "ZBAA", iata: "PEK", name: "Beijing Capital", latitude: 40.0801, longitude: 116.5846 },
  { icao: "ZSPD", iata: "PVG", name: "Shanghai Pudong", latitude: 31.1443, longitude: 121.8083 },
  { icao: "RJTT", iata: "HND", name: "Tokyo Haneda", latitude: 35.5494, longitude: 139.7798 },
  { icao: "RJAA", iata: "NRT", name: "Tokyo Narita", latitude: 35.7719, longitude: 140.3929 },
  { icao: "RKSI", iata: "ICN", name: "Seoul Incheon", latitude: 37.4602, longitude: 126.4407 },
  { icao: "WSSS", iata: "SIN", name: "Singapore Changi", latitude: 1.3644, longitude: 103.9915 },
  { icao: "VTBS", iata: "BKK", name: "Bangkok Suvarnabhumi", latitude: 13.69, longitude: 100.7501 },
  { icao: "YSSY", iata: "SYD", name: "Sydney Kingsford Smith", latitude: -33.9461, longitude: 151.1772 },
  { icao: "YMML", iata: "MEL", name: "Melbourne", latitude: -37.6733, longitude: 144.8433 },
  { icao: "NZAA", iata: "AKL", name: "Auckland", latitude: -37.0082, longitude: 174.785 },
  { icao: "FAOR", iata: "JNB", name: "Johannesburg O.R. Tambo", latitude: -26.1392, longitude: 28.246 },
  { icao: "HECA", iata: "CAI", name: "Cairo", latitude: 30.1219, longitude: 31.4056 },
  { icao: "GMMN", iata: "CMN", name: "Casablanca", latitude: 33.3675, longitude: -7.5899 },
  { icao: "KJFK", iata: "JFK", name: "New York JFK", latitude: 40.6413, longitude: -73.7781 },
  { icao: "KEWR", iata: "EWR", name: "Newark", latitude: 40.6895, longitude: -74.1745 },
  { icao: "KBOS", iata: "BOS", name: "Boston Logan", latitude: 42.3656, longitude: -71.0096 },
  { icao: "KIAD", iata: "IAD", name: "Washington Dulles", latitude: 38.9531, longitude: -77.4565 },
  { icao: "KATL", iata: "ATL", name: "Atlanta", latitude: 33.6407, longitude: -84.4277 },
  { icao: "KMIA", iata: "MIA", name: "Miami", latitude: 25.7959, longitude: -80.287 },
  { icao: "KORD", iata: "ORD", name: "Chicago O'Hare", latitude: 41.9742, longitude: -87.9073 },
  { icao: "KDFW", iata: "DFW", name: "Dallas Fort Worth", latitude: 32.8998, longitude: -97.0403 },
  { icao: "KDEN", iata: "DEN", name: "Denver", latitude: 39.8561, longitude: -104.6737 },
  { icao: "KLAX", iata: "LAX", name: "Los Angeles", latitude: 33.9416, longitude: -118.4085 },
  { icao: "KSFO", iata: "SFO", name: "San Francisco", latitude: 37.6213, longitude: -122.379 },
  { icao: "KSEA", iata: "SEA", name: "Seattle Tacoma", latitude: 47.4502, longitude: -122.3088 },
  { icao: "CYYZ", iata: "YYZ", name: "Toronto Pearson", latitude: 43.6777, longitude: -79.6248 },
  { icao: "CYVR", iata: "YVR", name: "Vancouver", latitude: 49.1967, longitude: -123.1815 },
  { icao: "MMMX", iata: "MEX", name: "Mexico City", latitude: 19.4363, longitude: -99.0721 },
  { icao: "SBGR", iata: "GRU", name: "São Paulo Guarulhos", latitude: -23.4356, longitude: -46.4731 },
  { icao: "SAEZ", iata: "EZE", name: "Buenos Aires Ezeiza", latitude: -34.8222, longitude: -58.5358 },
  { icao: "SCEL", iata: "SCL", name: "Santiago", latitude: -33.393, longitude: -70.7858 },
  { icao: "SKBO", iata: "BOG", name: "Bogotá El Dorado", latitude: 4.7016, longitude: -74.1469 },
];

// Airports whose coordinates fall inside a bbox { lamin, lamax, lomin, lomax }.
export function airportsInBbox(bbox) {
  if (!bbox) return [];
  const lamin = +bbox.lamin;
  const lamax = +bbox.lamax;
  const lomin = +bbox.lomin;
  const lomax = +bbox.lomax;
  return SAMPLE_AIRPORTS.filter(
    (a) => a.latitude >= lamin && a.latitude <= lamax && a.longitude >= lomin && a.longitude <= lomax
  );
}
